import type { ImageInfo } from '../../engine/worker/protocol.ts';

/**
 * An image's clickable area (oriented like the image), selectable and draggable like a text span. A drag that
 * starts on it while it is not selected draws a selection rectangle (on a scan, over its recognised words).
 */
export function ImageArea(props: { page: number; image: ImageInfo; area: React.CSSProperties; selected: boolean; mark: string; hover: boolean; previewed?: 'found' | 'locked'; disabled: boolean; drag?: { x0: number; y0: number; dx: number; dy: number }; startDrag: (e: React.PointerEvent) => void; startMarquee: (e: React.PointerEvent) => void; motion: React.CSSProperties; onPick: (e: React.MouseEvent) => void;
  /** a scan behind recognised words (Bug2 follow-up): a click goes to the text near it, a double-click selects the scan */
  background?: { onClick: (e: React.MouseEvent) => void };
}) {
  const { image: im, selected } = props;
  const bg = props.background && !selected ? props.background : undefined;
  return (
    <button
      data-testid={`image-${props.page}-${im.index}`}
      data-selected={selected ? 'true' : undefined}
      data-preview={props.previewed}
      title={im.locked ? `Image (cannot be changed: ${im.locked})` : bg ? 'The scanned page: double-click to select it' : 'Select the image'}
      disabled={props.disabled || !!im.locked}
      onClick={(e) => !props.drag && (bg ? bg.onClick(e) : props.onPick(e))}
      onDoubleClick={(e) => bg && !props.drag && props.onPick(e)}
      onPointerDown={(e) => (selected ? props.startDrag(e) : props.startMarquee(e))}
      className={props.hover ? 'obj' : 'obj no-hover'}
      style={{ cursor: im.locked ? 'not-allowed' : selected ? 'move' : bg ? 'default' : 'pointer', ...props.motion }}
    >
      <span className={props.mark} style={props.area} />
    </button>
  );
}
